
<template>
  <div class="page">
    <div class="page_header">
      <div class="page_header_circle"></div>
      마이페이지
    </div>
    <div class="page_contents">
      <div class="join_header">정보입력</div>
      <div>
        <div id="input-wrapper">
          <div class="form-group">
            <label for="companyName">사업자명</label>
            <div class="company-input">
              <input type="text" id="companyName" v-model="form.companyName" />
            </div>
          </div>
          <div class="form-group">
            <label for="businessType">사업자구분</label>
            <div class="businesstype-inputs">
              <label>
                <input type="radio" value="개인" v-model="form.businessType" />
                개인
              </label>
              <label>
                <input type="radio" value="법인" v-model="form.businessType" />
                법인
              </label>
            </div>
          </div>
          <div class="form-group">
            <label for="businessNumber">사업자번호</label>
            <div class="business-inputs">
              <input type="number" id="businessNumber1" v-model="form.businessNumber1" />
              <input type="number" id="businessNumber2" v-model="form.businessNumber2" />
              <input type="number" id="businessNumber3" v-model="form.businessNumber3" />
            </div>
          </div>
          <div class="form-group">
            <label for="managerName">대표자명</label>
            <div class="company-input">
              <input type="text" id="managerName" v-model="form.managerName" />
            </div>
          </div>
          <div class="form-group">
            <label for="phoneNumber">대표자 전화번호</label>
            <div class="phone-inputs">
              <input type="text" id="phoneNumber1" v-model="form.phoneNumber1" />
              <input type="text" id="phoneNumber2" v-model="form.phoneNumber2" />
              <input type="text" id="phoneNumber3" v-model="form.phoneNumber3" />
            </div>
          </div>
          <!-- 추가 입력 필드 -->
          <div class="form-group">
            <label for="managerPhone">담당자 전화번호</label>
            <div class="phone-inputs">
              <input type="text" id="managerPhone1" v-model="form.managerPhone1" />
              <input type="text" id="managerPhone2" v-model="form.managerPhone2" />
              <input type="text" id="managerPhone3" v-model="form.managerPhone3" />
            </div>
          </div>
          <div class="form-group">
            <label for="taxEmail">담당자 이메일</label>
            <div class="email-inputs">
              <input class="email1" type="text" v-model="form.email1" />
              <div class="dot">@</div>
              <input class="email2" type="text" v-model="form.email2" />
            </div>
          </div>
          <div class="form-group">
            <label for="companyAddress">주소</label>
            <div class="address-inputs">
              <input class="address1" readonly type="search" id="companyAddress1" v-model="form.companyAddress1" @click="searchAddr(1)" />
              <input class="address2" type="text" id="companyAddress2" v-model="form.companyAddress2" />
            </div>
          </div>
          <div class="form-group">
            <label for="addressDetail">상세주소</label>
            <div class="company-input">
              <input type="text" id="addressDetail" v-model="form.addressDetail" />
            </div>
          </div>
          <div class="form-group">
            <label for="companyAddress">주소2</label>
            <div class="address-inputs">
              <input class="address1" readonly type="search" id="companyAddress1" v-model="form.companyAddress21" @click="searchAddr(2)" />
              <input class="address2" type="text" id="companyAddress2" v-model="form.companyAddress22" />
            </div>
          </div>
          <div class="form-group">
            <label for="addressDetail">상세주소2</label>
            <div class="company-input">
              <input type="text" id="addressDetail" v-model="form.addressDetail2" />
            </div>
          </div>
          <div class="form-group">
            <label for="file">사업자등록증</label>
            <div class="filebox">
              <div class="file-name" 
                @click="downloadFile(form.file)"
              :style="{ color: form.file ? '#0078db' : '#db0028' }"
              @mouseover="showFilePreview($event, form.file)" 
              @mouseleave="hideSealPreview">
                {{ form.file ? form.file?.원파일명 : '미등록' }}
              </div>
              <div style="font-size: 14px;">{{ isEmpty(form.file) ? '' : formatTimeAgo(form.file.등록일시!) }}</div>
              <label for="file" @click="openFilePop('사업자등록증',null)">
                {{ isEmpty(form.file) ? '파일 등록' : '파일 재등록' }}
              </label>
              
            </div>
          </div>
          <div class="form-group">
            <label for="remarks">사용인감</label>
            <div class="filebox">
              <div v-if="form.사용인감등록여부" class="file-name" 
              :style="{ color: form.사용인감등록여부 ? '#0078db' : '#db0028' }"
              @mouseover="showFilePreview($event, form.seal)" 
              @mouseleave="hideSealPreview">
                {{ form.사용인감등록여부 ? '등록완료' : '미등록' }}
              </div>
              <div style="font-size: 14px;">{{ isEmpty(form.seal) ? '' : formatTimeAgo(form.seal.등록일시!) }}</div>
              <label for="file" @click="openFilePop('도장','사용인감')">
                {{ isEmpty(form.seal) ? '파일 등록' : '파일 재등록' }}
              </label>
            </div>
          </div>
          <div class="form-group">
            <label for="remarks">인감</label>
            <div class="filebox">
              <div v-if="form.인감등록여부" class="file-name" 
              :style="{ color: form.인감등록여부 ? '#0078db' : '#db0028' }">
                {{ form.인감등록여부 ? '등록완료' : '미등록' }}
              </div>
              <div style="font-size: 14px;">{{ isEmpty(form.seal2) ? '' : formatTimeAgo(form.seal2.등록일시!) }}</div>
              <label for="file" @click="openFilePop('도장','인감')">
                {{ isEmpty(form.seal2) ? '파일 등록' : '파일 재등록' }}
              </label>
            </div>
          </div>
          <div class="form-group">
            <label for="remarks">비고</label>
            <div class="company-input">
              <input type="text" id="remarks" v-model="form.remarks" />
            </div>
          </div>
        </div>
        <div class="submit-btn">
          <button class="submit-button" @click="updateUser">수정하기</button>
        </div>
      </div>
    </div>
  </div>
  <div 
  v-if="previewVisible" 
  class="seal-preview" 
  :style="{ left: previewPosition.x + 'px', top: previewPosition.y + 'px' }"
>
  <img :src="previewImageUrl"/>
</div>
  <UserFileUploadPop :등록구분="fileParam.등록구분!" :도장구분="fileParam.도장구분" :oldSeq="sealSeq" @closePopup="closePopup" v-if="toggleFileUploadPop"></UserFileUploadPop>
</template>

<script setup lang="ts">
import userAPI from "@/api/userAPI";
import UserFileUploadPop from "@/components/popup/UserFileUploadPop.vue";
import { Member, MemberFileParam, saveFile } from "@/common/types";
import { formatTimeAgo, isEmpty } from "@/common/util";
import { reactive, onMounted, ref, onBeforeUnmount } from "vue";
// 상태 관리
const form = reactive({
  companyName: "",
  businessType: "개인",
  businessNumber1: "",
  businessNumber2: "",
  businessNumber3: "",
  managerName: "",
  phoneNumber1: "",
  phoneNumber2: "",
  phoneNumber3: "",
  managerPhone1: "",
  managerPhone2: "",
  managerPhone3: "",
  email1: "",
  email2: "",
  companyAddress1: "",
  companyAddress2: "",
  addressDetail: "",
  companyAddress21: "",
  companyAddress22: "",
  addressDetail2: "",
  remarks: "",
  file: {} as saveFile,
  seal: {} as saveFile,
  seal2: {} as saveFile,
  businessLicense: "",
  casualSeal: "",
  registeredSeal: "",
  사용인감등록여부: false,
  인감등록여부: false,
});

const isPreviewTracking = ref(false);
const previewVisible = ref(false);
const previewImageUrl = ref('');
const previewPosition = ref({ x: 0, y: 0 });
const sealSeq = ref();
const sealFileUrl = ref()
const businessnoUrl = ref()
const showFilePreview = async (event: MouseEvent, file: any) => {
  previewPosition.value = {
    x: event.clientX + 10,
    y: event.clientY + 10
  };
  
  try {
    if (file && file.저장순번) {
      const fileType = file.원파일명.toLowerCase().endsWith('.pdf') ? 'pdf' : 'image';
      // 파일 다운로드 (ArrayBuffer 형식으로)
      let res
      let blob
      if(fileType !== 'pdf') {
        if(file.자료식별값2 === '도장') {
          console.log(sealFileUrl.value);
          if(sealFileUrl.value) {
            previewImageUrl.value = URL.createObjectURL(sealFileUrl.value);
          } else {
            res = await userAPI.sealFile(file.저장순번,file.자료식별값3,'3111');
            blob = new Blob([res.data]);
            previewImageUrl.value = URL.createObjectURL(blob);
            sealFileUrl.value = blob;
          }
        } else if(file.자료식별값2 === '사업자등록증') {
          if(businessnoUrl.value) {
            previewImageUrl.value = URL.createObjectURL(businessnoUrl.value);
          } else {
            res = await userAPI.priviewFile(file.저장순번);
            blob = new Blob([res.data]);
            previewImageUrl.value = URL.createObjectURL(blob);
            businessnoUrl.value = blob;
          }
        }
      } else {
      previewImageUrl.value = require('@/assets/images/pdf.png');
      }
      previewVisible.value = true;
      isPreviewTracking.value = true;
    }
  } catch (error) {
    console.error('파일 미리보기 로드 실패:', error);
  }
};

const handleGlobalMouseMove = (event: MouseEvent) => {
  if (!isPreviewTracking.value || !previewVisible.value) return;
  
  // 미리보기 요소 참조
  // 이벤트가 발생한 요소 확인
  const target = event.target as HTMLElement;
  const isFileNameElement = target.closest('.file-name');

  // file-name 클래스를 가진 요소가 아닌 곳에 마우스가 있으면 미리보기 숨김
  if (!isFileNameElement) {
    hideSealPreview();
    return;
  }
  
};

const hideSealPreview = () => {
  previewVisible.value = false;
  isPreviewTracking.value = false;
  if (previewImageUrl.value && previewImageUrl.value.startsWith('blob:')) {
    URL.revokeObjectURL(previewImageUrl.value);
    previewImageUrl.value = '';
  }
};

const toggleFileUploadPop = ref(false);
const closePopup = (data: any) => {
  toggleFileUploadPop.value = false;
  if(data.refresh) {
    userDetail();
  }
};
const openFilePop = (data: string,data2: string|null) => {
  fileParam.value.등록구분 = data;
  fileParam.value.도장구분 = data2;
  if(data2) {
    sealSeq.value = form.seal?.저장순번;
  }
  toggleFileUploadPop.value = true;
};
// 주소 검색
const searchAddr = (seq: number) => {
  const daum = (window as any).daum;
  new daum.Postcode({
    oncomplete(data: any) {
      if(seq === 1) {
        form.companyAddress1 = data.zonecode;
        form.companyAddress2 = data.address;
      } else {
        form.companyAddress21 = data.zonecode;
        form.companyAddress22 = data.address;
      }
    },
  }).open();
};
const fileParam:MemberFileParam = ref({
  등록구분: null,
  도장구분: null,
  인감비밀번호: null
})
const img = ref()
const imgPreview = () => {
  
  userAPI
    .sealFile(1, '사용인감', '')
    .then((res: any) => {
      const 사용인감 = res.data
      const url = window.URL.createObjectURL(new Blob([사용인감]))
      img.value = url
    })
}

// API 호출 및 데이터 바인딩
const userDetail = async () => {
  try {
    const res = await userAPI.mypage();
    const userData = res.data.data;
    form.companyName = userData.사업자명 || "";
    form.businessType = userData.사업자구분;
    form.businessNumber1 = userData.사업자번호?.slice(0, 3) || "";
    form.businessNumber2 = userData.사업자번호?.slice(3, 5) || "";
    form.businessNumber3 = userData.사업자번호?.slice(5) || "";
    form.managerName = userData.담당자명 || "";
    form.phoneNumber1 = userData.대표자전화번호?.slice(0, 3) || "";
    form.phoneNumber2 = userData.대표자전화번호?.slice(3, 7) || "";
    form.phoneNumber3 = userData.대표자전화번호?.slice(7) || "";
    form.managerPhone1 = userData.담당자전화번호?.slice(0, 3) || "";
    form.managerPhone2 = userData.담당자전화번호?.slice(3, 7) || "";
    form.managerPhone3 = userData.담당자전화번호?.slice(7) || "";
    form.email1 = userData.담당자이메일?.split("@")[0] || "";
    form.email2 = userData.담당자이메일?.split("@")[1] || "";
    form.companyAddress1 = userData.우편번호 || "";
    form.companyAddress2 = userData.주소 || "";
    form.addressDetail = userData.상세주소 || "";
    form.companyAddress21 = userData.우편번호2 || "";
    form.companyAddress22 = userData.주소2 || "";
    form.addressDetail2 = userData.상세주소2 || "";``
    form.remarks = userData.비고 || "";
    form.file = userData.사업자등록증;
    form.seal = userData.사용인감;
    form.seal2 = userData.인감;
    form.사용인감등록여부 = userData.사용인감등록여부 || false;
    form.인감등록여부 = userData.인감등록여부 || false;
    // form.fileName = userData.사업자등록증?.[0]?.원파일명 || "";
  } catch (error) {
    console.error("Failed to fetch user details:", error);
  }
  console.log(form.file);
};

// 수정 API 호출
const updateUser = async () => {
  try {
    // 서버에 전송할 데이터 형식
    const payload: Partial<Member> = {
      사업자명: form.companyName,
      사업자구분: form.businessType,
      사업자번호: `${form.businessNumber1}${form.businessNumber2}${form.businessNumber3}`,
      대표자명: form.managerName,
      대표자전화번호: `${form.phoneNumber1}${form.phoneNumber2}${form.phoneNumber3}`,
      담당자명: form.managerName,
      담당자전화번호: `${form.managerPhone1}${form.managerPhone2}${form.managerPhone3}`,
      담당자이메일: `${form.email1}@${form.email2}`,
      우편번호: form.companyAddress1,
      주소: form.companyAddress2,
      상세주소: form.addressDetail,
      우편번호2: form.companyAddress21,
      주소2: form.companyAddress22,
      상세주소2: form.addressDetail2,
      비고: form.remarks,
    };

    // PATCH 요청
    await userAPI.updateUser(payload).then((res) => {
      console.log("res", res);
      alert("수정이 완료되었습니다!");
    });
  } catch (error) {
    console.error("수정 실패:", error);
    alert("수정에 실패했습니다. 다시 시도해주세요.");
  }
};
const downloadFile = (file: any) => {
  if (file) {
    userAPI.downloadUserFile(file.저장순번, file.원파일명);
  }
}
onMounted(() => {
  userDetail();
  document.addEventListener('mousemove', handleGlobalMouseMove);
});

onBeforeUnmount(() => {
  // 이벤트 리스너 제거
  document.removeEventListener('mousemove', handleGlobalMouseMove);
});
</script>

<style scoped>
.page_header {
  /* border-bottom: 1px solid #e0e0e0; */
  padding: 40px 0px;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 26px;
  display: flex;
  gap: 16px;
  align-items: center;
  line-height: 35px;
}
.page_header_circle {
  width: 18px;
  height: 18px;
  border-radius: 18px;
  border: 5px solid #e5e8ec;
}

.page_contents {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-bottom: 100px;
  align-items: center;
}

.contents_div {
  width: 1010px;
}

.form-group {
  width: 775px;
  display: flex;
  align-items: center;
  height: 71px;
  border-bottom: 0.5px solid #d0d0d0;
}

label {
  width: 150px;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  margin-right: 20px;
  text-align: left;
}

input::-webkit-inner-spin-button {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
}

input[type="text"],
input[type="number"],
input[type="search"],
button {
  width: 249px;
  height: 39px;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #d0d0d0;
  background-color: #f6f7fb;
}

.company-input input {
  width: 249px;
  height: 39px;
}
.businesstype-inputs {
  display: flex;
}
.businesstype-inputs label {
  width: auto;
  margin-right: 20px;
}
.business-inputs {
  display: flex;
}

.business-inputs input {
  width: 113px;
  height: 39px;
  margin-right: 8px;
  display: flex;
}

.phone-inputs {
  display: flex;
}

.phone-inputs input {
  width: 113px;
  height: 39px;
  margin-right: 8px;
  display: flex;
}

.email-inputs {
  display: flex;
  align-items: center;
}

.email-inputs .email1 {
  width: 113px;
  height: 39px;
}

.email-inputs .email2 {
  width: 198px;
  height: 39px;
}

.email-inputs span {
  margin: 0 5px;
}

.dot {
  margin-left: 15px;
  margin-right: 15px;
}

.address-inputs {
  display: flex;
  align-items: center;
}

.address-inputs .address1 {
  width: 113px;
  height: 39px;
  margin-right: 8px;
  background-image: url("@/assets/images/icon-search.png");
  background-repeat: no-repeat;
  background-position: right 5px center;
  background-size: 16px 16px;
  cursor: pointer;
}

.address-inputs .address2 {
  width: 234px;
  height: 39px;
}

.filebox {
  display: inline-block;
  height: 40px;

  vertical-align: middle;
  border-radius: 4px;
  width: 78%;
  color: #000;
  display: flex;
  align-items: center;
  gap: 18px;
}
.file-name {
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 14px;
}

.filebox label {
  text-align: center;
  width: 113px;
  height: 39px;
  padding: 9px 21px;
  border-radius: 4px;
  color: #fff;
  vertical-align: middle;
  background-color: #383838;
  border: 1px solid #d0d0d0;
  cursor: pointer;
}

.filebox input[type="file"] {
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  overflow: hidden;
}

.submit-button {
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 16px;
  width: 189px;
  height: 41px;
  background-color: #3382e9;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;
  margin-top: 52px;
  padding: 10px 65px 9px 65px;
  text-align: center;
  line-height: 22px;
}

.submit-btn {
  text-align: center;
}

.auth-button {
  background-color: #383838;
  color: white;
  padding: 9px 23px;
  cursor: pointer;
  width: 101px;
}

.form_label {
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Bold";
}

#input-wrapper {
  border-bottom: 3px solid black;
  border-top: 3px solid black;
}

.join_header {
  font-size: 16px;
  font-family: "Noto Sans CJK KR-Bold";
  padding-bottom: 17px;
  width: 775px;
  display: flex;
}

.join-container {
  width: 100%;
  margin: auto;
}

.join-agree-container {
  margin-bottom: 49px;
}

.checkbox-container {
  display: inline-block;
  width: 100%;
  align-items: center;
  margin-bottom: 10px;
}

.checkbox-container input[type="checkbox"] {
  display: inline-block;
  margin-right: 5px;
}

.agree-privacy {
  font-family: "Noto Sans CJK KR-Light";
  padding-left: 8px;
}

.button-container {
  text-align: center;
}

button {
  background-color: #3382e9;
  font-family: "Noto Sans CJK KR-Medium";
  color: white;
  width: 189px;
  height: 41px;
  padding: 10px 20px;
  border: none;
  border-radius: px;
  cursor: pointer;
  display: inline-block;
}

.steps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 696px;
  padding-bottom: 65px;
}

.step {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.step_circle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  width: 12px;
  height: 12px;
  background: #d8d8d8;
  position: relative;
}

.step.active .step_circle {
  border: 3px solid #337ab7;
  width: 18px;
  height: 18px;
  background: white;
}

.step.active .step_circle div {
  color: #337ab7;
}

.step_line {
  height: 2px;
  background: #d8d8d8;
  width: 214px;
}

.active .step_line {
  width: 208px;
  background: #337ab7;
}

.step_labels {
  display: flex;
  flex-direction: row;
  /* width: 765px; */
}

.step_label {
  position: absolute;
  width: 150px;
  text-align: center;
  bottom: -31px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Regular";
  line-height: 19px;
}

.page_header_line {
  width: 36px;
  border-bottom: 2px solid #000000;
  margin-bottom: 47px;
}

.drop-zone {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  transition: background-color 0.3s;
  display: flex;
  height: 65px;
  align-items: center;
}
.drop-zone.active {
  background-color: #f0f8ff !important;
}
.drop-zone:hover {
  background-color: #f0f0f0 !important;
}
.seal-preview {
  position: fixed;
  z-index: 1000;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  padding: 5px;
  max-width: 200px;
  max-height: 200px;
}

.seal-preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.file-name {
  cursor: pointer;
}
</style>
